import { createFileRoute } from "@tanstack/react-router";
import TmsAnxiety from "@/pages/TmsAnxiety";
export const Route = createFileRoute("/services/anxiety")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS for Anxiety | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Advanced Transcranial Magnetic Stimulation (TMS) therapy for anxiety disorders in Coral Springs, FL. Non-invasive, non-drug Apollo TMS system. Call.",
        },
        {
          property: "og:title",
          content: "TMS for Anxiety | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Advanced Transcranial Magnetic Stimulation (TMS) therapy for anxiety disorders in Coral Springs, FL. Non-invasive, non-drug Apollo TMS system. Call.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/services/anxiety",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/services/anxiety",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsAnxiety />;
}
